<template>
  <b-modal ref="modal" size="xl" hide-footer scrollable
           :title="title" body-class="itm-body" @hidden="onHidden">
    <monetaries-table v-if="visible" :filters="filters" :columns="columns" :has-selection="false" :lazy="false"/>
  </b-modal>
</template>

<script>
import MonetariesTable from '@/components/tables/MonetariesTable';

/**
 * Drill-down used by the Client/User Insights stat cards: shows the raw
 * monetary transactions behind a KPI, using the standard MonetariesTable.
 */
export default {
  name: 'InsightTransactionsModal',
  components: { MonetariesTable },
  data: () => ({
    visible: false,
    title: '',
    filters: {},
  }),
  computed: {
    columns() {
      return [
        { key: 'id', enable: true },
        { key: 'clientDetails', enable: true },
        { key: 'clientDetails.accountId', enable: true },
        { key: 'amount', enable: true },
        { key: 'currency', enable: true },
        { key: 'type', enable: true },
        { key: 'action', enable: true },
        { key: 'depositorUserId', enable: true },
        { key: 'isFtd', enable: true },
        { key: 'registrationTime', enable: true },
        { key: 'status', enable: true },
      ];
    },
  },
  methods: {
    show(title, filters) {
      this.title = title;
      this.filters = filters || {};
      this.visible = true;
      this.$refs.modal.show();
    },
    onHidden() {
      this.visible = false;
      this.filters = {};
    },
  },
};
</script>

<style lang="scss">
.itm-body {
  min-height: 320px;
  /* Never outgrow the viewport: header/title and the table's pagination must
     always stay reachable — the body scrolls internally instead. */
  max-height: calc(100vh - 190px);
  overflow-y: auto;
}
</style>
